module.exports = __webpack_public_path__ + "media/buy-now/sample_box4-1168ee97.png";